import {
  Box,
  Checkbox,
  Chip,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const MultiselectCheckBoxChip = ({
  name,
  label,
  options,
  selectedOptions,
  handleSelectCheckboxMultiple,
  isDisabled = false,
  isRequired = false,
}) => {
  return (
    <FormControlWrapper fullWidth>
      <InputLabel id="selectLabel">{label}</InputLabel>
      <Select
        labelId="selectLabel"
        id="selectLabelCheckbox"
        name={name}
        label={label}
        multiple
        value={selectedOptions || []}
        disabled={isDisabled}
        required={isRequired}
        onChange={handleSelectCheckboxMultiple}
        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options &&
          options.map((item, index) => (
            <MenuItem key={index} value={item.option}>
              <Checkbox checked={selectedOptions.includes(item.option)} />
              <ListItemText primary={item.value || item.option} />
            </MenuItem>
          ))}
      </Select>
    </FormControlWrapper>
  );
};
